import React, { useState } from "react";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import TabContext from "@mui/lab/TabContext";
import Divider from "@mui/material/Divider";
import { Parameters, Ratio, Property, Other, Occupation } from "./Parameters";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { Threshold } from "components/Patrimoine/Generic/Parameters/Threshold";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
    textTransform: "none",
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
  },
  tabPanel : {
    padding: "0",
  }
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export default function VerticalTabs(props) {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={2} lg={2}>
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={handleTabChange}
            aria-label="Vertical tabs example"
            className={classes.tabs}
            TabIndicatorProps={{ style: { background: "#91C73C" } }}
          >
            <Tab className={classes.tab} label="Paramètres" {...a11yProps(0)} />
            <Tab className={classes.tab} label="Ratios" {...a11yProps(1)} />
            <Tab className={classes.tab} label="Propriétés ou caractéristiques physiques" {...a11yProps(2)} />
            <Tab className={classes.tab} label="Occupation" {...a11yProps(3)} />
            <Tab className={classes.tab} label="Autres" {...a11yProps(4)} />
            <Tab className={classes.tab} label="Seuils caractéristiques" {...a11yProps(5)} />
          </Tabs>
        </GridItem>

        <GridItem xs={12} sm={12} md={10} lg={10}>
          <TabPanel value={value} index={0} className={classes.tabPanel} >
            <Parameters />
          </TabPanel>
          <TabPanel value={value} index={1} className={classes.tabPanel} >
            <Ratio />
          </TabPanel>
          <TabPanel value={value} index={2} className={classes.tabPanel} >
            <Property />
          </TabPanel>
          <TabPanel value={value} index={3} className={classes.tabPanel} >
            <Occupation />
          </TabPanel>
          <TabPanel value={value} index={4} className={classes.tabPanel} >
            <Other />
          </TabPanel>
          <TabPanel value={value} index={5} className={classes.tabPanel} >
            <Threshold />
          </TabPanel>
        </GridItem>
      </GridContainer>
    </div>
  );
}
